// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Rem from '../static/rem'
import { get, post,setAuthToken } from '../static/request'
import Toasted from 'vue-toasted'
import VueClipboard from 'vue-clipboard2'
 
import VueApollo from 'vue-apollo'
import apolloProvider from './apollo'
Vue.use(VueApollo)
 

Vue.use(VueClipboard)
Vue.use(Toasted)
 
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$setAuthToken = setAuthToken

Vue.config.productionTip = false
 

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  provide:apolloProvider.provide(),
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js